import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ArticlePortugalBrasil from "../pages/article/cssbuy-sheet-portugal-brasil";
import ArticleMelhor2026 from "../pages/article/melhor-cssbuy-spreadsheet-2026";
import ArticleSeguro from "../pages/article/cssbuy-spreadsheet-seguro";
import ArticleComprar from "../pages/article/como-comprar-cssbuy-sheet";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guia-cssbuy-sheet-2026",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-sheet-portugal-brasil",
    element: <ArticlePortugalBrasil />,
  },
  {
    path: "/melhor-cssbuy-spreadsheet-2026",
    element: <ArticleMelhor2026 />,
  },
  {
    path: "/cssbuy-spreadsheet-seguro",
    element: <ArticleSeguro />,
  },
  {
    path: "/como-comprar-cssbuy-sheet",
    element: <ArticleComprar />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;